import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'keyDisplayName',
  standalone: true,
})
export class KeyDisplayNamePipe implements PipeTransform {
  /**
   * This pipe transforms the object name key to this display name
   * @param value This is the object key (e.g. driverName, busId)
   * @returns driver name, bus id
   */
  transform(value: string): string {
    let displayName = '';
    for (let i = 0; i < value?.length; i++) {
      if (i == 0 || value[i] != value[i].toUpperCase()) {
        displayName += value[i];
      } else if (value[i] == value[i].toUpperCase() && value[i - 1] == value[i - 1].toUpperCase()) {
        // handle cases like "ID"
        displayName += value[i];
      } else {
        displayName += ' ' + value[i];
      }
    }
    return displayName;
  }
}
